import { useLatestBuild } from '@/hooks/useLatestBuild'
import { DOWNLOAD_ANCHOR, LOGIN_URL, MAC_BUILD } from '@/lib/landing'
import { ButtonLink, DownloadIcon, GenieMark } from './primitives'

/** Dark grainy call to action: one line, the download, and the browser alternative. */
export function FinalCta() {
  const build = useLatestBuild()
  return (
    <section className="landing-shell pt-28 pb-6">
      <div className="grain relative overflow-hidden rounded-[3px] bg-dark p-8 text-on-dark md:p-10">
        <div
          aria-hidden
          className="pointer-events-none absolute -top-40 -left-24 size-[520px] rounded-full bg-[radial-gradient(closest-side,rgba(255,238,206,0.2),transparent)]"
        />
        <div className="relative z-10 grid gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)] lg:items-end">
          <div>
            <GenieMark className="size-8" />
            <h2 className="mt-6 max-w-md text-[36px] leading-[1.1] tracking-[-0.03em]">
              Put a genie on your desk. It runs on your own hardware.
            </h2>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <ButtonLink href={DOWNLOAD_ANCHOR} variant="light">
                <DownloadIcon />
                Download for macOS
              </ButtonLink>
              <span className="mono-label text-on-dark-2">
                <span className="num">{build.size}</span> · {MAC_BUILD.requirements}
              </span>
            </div>
          </div>
          <div className="rounded-[3px] border border-white/10 bg-black/40 p-5 lg:justify-self-end lg:max-w-sm">
            <p className="text-[14px] leading-relaxed text-on-dark-2">
              <span className="text-on-dark">No Mac at hand?</span> Genie also runs in the browser, on the same account.
            </p>
            <ButtonLink href={LOGIN_URL} variant="light" size="sm" className="mt-4">
              Sign in <span aria-hidden>→</span>
            </ButtonLink>
          </div>
        </div>
      </div>
    </section>
  )
}
